module.exports = __webpack_public_path__ + "media/OSZCZEDNOSCI.cdf0e518.mp3";